<template>
    <div>
        <span :class="levelMeta.classes.text">
            {{ levelMeta.label }}:
        </span>
        {{ validationInfo.message }}
        <div v-html="validationInfo.tooltip"></div>
    </div>
</template>

<script>
import {
    getFieldValidationInfo,
    getFieldValidationLevelMeta
} from '../../../../../../../types/document-viewer/field/modules/validation'

export default {
    name: 'AgGridCellValidationMessage',
    props: {
        validation: {
            type: Object,
            required: true
        }
    },
    computed: {
        levelMeta() {
            return getFieldValidationLevelMeta(this.validation.level)
        },

        validationInfo() {
            return getFieldValidationInfo({key: this.validation.key, params: this.validation.params})
        }
    }
}
</script>
